(() => {
  const ROOT_SELECTOR = '[data-im-pdp-accordion-root]';
  const ITEM_SELECTOR = 'details[data-im-pdp-accordion-item]';
  const DESKTOP_QUERY = '(min-width: 990px)';
  const MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const ANIMATION_DURATION = 280;
  const ANIMATION_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  const initRoot = (root) => {
    if (!root || root.dataset.imPdpAccordionReady === 'true') return;

    const accordions = Array.from(root.querySelectorAll(ITEM_SELECTOR));
    if (!accordions.length) return;

    const desktopMedia = window.matchMedia(DESKTOP_QUERY);
    const reducedMotionMedia = window.matchMedia(MOTION_QUERY);
    let syncing = false;
    const animationMap = new WeakMap();

    const setOpen = (accordion, shouldOpen) => {
      if (!accordion || accordion.open === shouldOpen) return;
      syncing = true;
      accordion.open = shouldOpen;
      accordion.style.height = '';
      accordion.style.overflow = '';
      delete accordion.dataset.imAnimating;
      syncing = false;
    };

    const finishAnimation = (accordion) => {
      const running = animationMap.get(accordion);
      if (running) {
        running.onfinish = null;
        running.oncancel = null;
      }
      animationMap.delete(accordion);
      accordion.style.height = '';
      accordion.style.overflow = '';
      delete accordion.dataset.imAnimating;
    };

    const animateOpen = (accordion, summary) => {
      if (reducedMotionMedia.matches) {
        setOpen(accordion, true);
        return;
      }

      const startHeight = `${summary.offsetHeight}px`;
      setOpen(accordion, true);
      const endHeight = `${accordion.offsetHeight}px`;
      accordion.dataset.imAnimating = 'opening';
      accordion.style.height = startHeight;
      accordion.style.overflow = 'hidden';

      const animation = accordion.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: ANIMATION_DURATION,
          easing: ANIMATION_EASING,
        }
      );

      animationMap.set(accordion, animation);
      animation.onfinish = () => finishAnimation(accordion);
      animation.oncancel = () => finishAnimation(accordion);
    };

    const animateClose = (accordion, summary) => {
      if (reducedMotionMedia.matches) {
        setOpen(accordion, false);
        return;
      }

      const startHeight = `${accordion.offsetHeight}px`;
      const endHeight = `${summary.offsetHeight}px`;
      accordion.dataset.imAnimating = 'closing';
      accordion.style.height = startHeight;
      accordion.style.overflow = 'hidden';

      const animation = accordion.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: ANIMATION_DURATION,
          easing: ANIMATION_EASING,
        }
      );

      animationMap.set(accordion, animation);
      animation.onfinish = () => {
        setOpen(accordion, false);
        finishAnimation(accordion);
      };
      animation.oncancel = () => finishAnimation(accordion);
    };

    const applyDefaultState = ({ force = false } = {}) => {
      const isDesktop = desktopMedia.matches;

      accordions.forEach((accordion) => {
        if (!force && accordion.dataset.userToggled === 'true') return;

        const shouldOpen = isDesktop
          ? accordion.dataset.openDesktop === 'true'
          : accordion.dataset.openMobile === 'true';
        setOpen(accordion, shouldOpen);
      });
    };

    accordions.forEach((accordion) => {
      const summary = accordion.querySelector('.im-accordion__summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (syncing || accordion.dataset.imAnimating) return;

        accordion.dataset.userToggled = 'true';
        if (accordion.open) {
          animateClose(accordion, summary);
        } else {
          animateOpen(accordion, summary);
        }
      });
    });

    applyDefaultState({ force: true });

    const onBreakpointChange = () => applyDefaultState({ force: false });
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', onBreakpointChange);
    } else if (desktopMedia.addListener) {
      desktopMedia.addListener(onBreakpointChange);
    }

    root.dataset.imPdpAccordionReady = 'true';
  };

  const init = (context = document) => {
    context.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });
})();
